import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ConfirmMpsTargetsSplitDialogContent } from './ConfirmMpsTargetsSplitDialogContent'

interface IProps {
  isShowDialog: boolean
  mpsSplitMessage: string
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmMpsTargetsSplitDialog = ({
  isShowDialog,
  mpsSplitMessage,
  onConfirm,
  onClose,
}: IProps) => {
  const contentProps = useMemo(() => {
    return { mpsSplitMessage, onConfirm, onClose }
  }, [mpsSplitMessage, onConfirm, onClose])

  return (
    <ModalDialog
      size={'xs'}
      show={isShowDialog}
      content={ConfirmMpsTargetsSplitDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
